import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "./App.css"; // Import CSS file for animations

function About() {
  const { page } = useParams();

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <div className="pb-16 bg-gray-200 relative slide-in"> {/* Add slide-in class here */}
      <div className="relative">
        <img
          src="images/home11.jpg"
          className="w-full h-64 relative object-cover"
          alt="Image Description"
        />
        <h1 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-3xl sm:text-2xl font-bold text-white">
          Who We Are
        </h1>
      </div>

      <h1 className="px-4 text-xl text-black font-bold py-3 text-center ">
        Balozi Wa Amani:
        <br />
        We can't help everyone, but everyone can help someone.
      </h1>

      <div className="flex justify-center items-center">
        <p className="text-lg text-black text-center text-italic px-4">
          Balozi Wa Amani CBO is registered as a community-based Organization. The group was founded after the post-election violence that occured in Kenya. The formation of the group came out during the <a href="https://www.unhabitatyouth.org/en/" target="_blank" className="text-black font-semibold">UN Habitat's Youth as Agents of Peace forum in Gigiri.</a> Balozi Wa Amani Initiative became an umbrella organization that brings most youths from the slums together for outreach activities in the region.
        </p>
      </div>

      <h1 className="px-4 py-2 text-xl text-black py-3 text-center">
       <h3 classname="font-bold text-black">Vision:</h3>

        A peaceful Kenya for All
      </h1>

      <div className="px-4 ">
        <h5 className="text-center font-bold pb-3">
          We provide care and assistance that surpasses mere basic needs. We
          provide:{" "}
        </h5>
        <div className="rounded-md bg-slate-300 py-8  px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div className="flex flex-col items-center">
            <img
              width="50"
              height="50"
              src="https://img.icons8.com/emoji/48/palms-up-together-medium-skin-tone.png"
              className="mx-auto"
              alt="experimental-charity-hands"
            />

            <h5 className="text-center font-bold text-red-600">
              Essential Resources
            </h5>
            <h6 className="text-center break-normal">
              They pave the way for a brighter tomorrow.
            </h6>
          </div>

          {/* Add more similar divs for additional items */}

          <div className="flex flex-col items-center mt-8 md:mt-0 md:ml-8">
            <img
              width="48"
              height="48"
              src="https://img.icons8.com/fluency/48/polo-shirt.png"
              className="mx-auto"
              alt="polo-shirt"
            />
            <h5 className="text-center font-bold text-red-600">Clothing</h5>
            <h6 className="text-center">
              From our closets to theirs, let's share the warmth.
            </h6>
          </div>

          <div className="flex flex-col items-center mt-8 md:mt-0 md:ml-8">
            <img
              width="48"
              height="48"
              src="https://img.icons8.com/color/48/charity-donation.png"
              className="mx-auto"
              alt="country-house"
            />
            <h5 className="text-center font-bold text-red-600">Donations</h5>
            <h6 className="text-center">
              It's not how much we give but how much love we put into giving.
            </h6>
          </div>
        </div>
      </div>
     

      {/* LEADERS */}
      <div className="bg-gray-200">
        <h2 className="text-center text-3xl font-bold py-8 text-black font-roboto overline">OUR LEADERSHIP</h2>
        <p className="px-4 mx-2 font-bold text-center text-lg">Meet the inspiring leaders shaping the future of our organization with their vision and expertise:</p>
        <h6 className="text-center text-base font-light text-black py-2">"Moved by Compassion, United by Aspiration"</h6>
        <div className="flex justify-center flex-wrap gap-4">
          <LeadershipCard name="Kevin Oduor(Balozi)" position="Executive Director & Founder" image="profile/balozi.jpg" />
          <LeadershipCard name="Patrick Obadha" position="Chairman" image="profile/partrick.jpg" />
          <LeadershipCard name="Grace Wanyagia" position="Secretary" image="profile/grace.jpg" />
          <LeadershipCard name="Judy Gathuita" position="Finance Director" image="profile/judy.jpg" />
          
          {/* Add more leadership cards here */}
        </div>
      </div>

      <div className="py-16"> 
        <h2 className="text-center sm:text-2xl text-lg  font-home font-bold tracking-tight text-red-700">
          "Join forces with us as we march towards a better future. Together, let's paint the world with the brushstrokes of hope, crafting a landscape where every child's smile symbolizes resilience."
        </h2>

        <div className='pb-4 py-8 flex items-center justify-center'>
          <Link to="/Donate">
            <button className='px-24 bg-red-600 rounded-md py-2.5 text-black text-lg font-bold transition-transform transform hover:scale-110'>Take Action</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

function LeadershipCard({ name, position, image }) {
  return (
    <div className="bg-white shadow-2xl border rounded-none py-2 mx-4 px-6 flex items-center justify-center transition-transform transform hover:scale-105">
      <img
        className="h-28 w-28 sm:h-28 sm:w-28 object-cover rounded-full"
        src={image}
        alt={name}
      />
      <div className="p-4">
        <h3 className="text-center text-xl font-bold">{name}</h3>
        <h2 className="text-center text-lg">{position}</h2>
      </div>
    </div>
  );
}

export default About;
